import { Injectable } from '@angular/core';
import { environment } from '@env';

@Injectable({ providedIn: 'root' })
export class StorageService {
  getCurrencyIcon(appId: string) {
    return `${environment.firebaseStorageUrl}o/projects%2F${appId}%2FcurrenciesIcons%2Frgn-coin.png?alt=media`;
  }
}
